<!--在途账单列表-->
<template>
  <div>
    <van-nav-bar :title="title" v-if="titleShow">
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="哥哥找过了,没有更多了,爱宝爱宝"
          loading-text="宝不着急,哥哥正在找,嗷呜~"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
      >
        <van-swipe-cell v-for="item in list" :key="item.finId">

          <van-cell>
            <!-- 使用 title 插槽来自定义标题 -->
            <template slot="title">
              <van-row type="flex" justify="space-between">
                <van-col span="11" >
                  <span style="font-size: 20px">{{splitDate(item.inputDate)}}</span>
                  <span> {{splitTime(item.inputDate)}}</span>
                </van-col>
                <van-col span="6">
                  <van-tag  plain  :type="getFinType(item.finType)" style="float: right;">{{item.finTypeName}}</van-tag>
                  <van-tag  plain  :type="getBillType(item.billType)" style="float: right;">{{item.billTypeName}}</van-tag>
                </van-col>
                <van-col span="7">
                  <span style="font-size: 20px;float: right;">￥{{item.amount}}</span>
                </van-col>
              </van-row>
              <van-row type="flex" v-if="overdraftArr.indexOf(item.billType + '') != -1">
                <van-col span="6" >分期</van-col>
                <van-col span="9" ><span style="float:left">{{"还" + item.returnedCnt + "/共" +item.instalmentsCnt}}期</span></van-col>
                <van-col span="9"><span style="color:#969799;font-size: 12px">还{{checkInteger(item.repayment)}}/余{{(item.amount-item.repayment).toFixed(2)}}</span></van-col>
              </van-row>
              <van-row type="flex" v-if="storeArr.indexOf(item.billType + '') != -1">
                <van-col span="6" >储值</van-col>
                <van-col span="9" ></van-col>
                <van-col span="9"><span style="color:#969799;font-size: 12px">剩余{{item.transBalance}}</span></van-col>
              </van-row>

              <van-row type="flex" v-if="item.finType == 12101">
                <van-col span="24" >
                  <van-tag  plain round  type="warning" style="margin-top:5px">{{item.payerName}}付款</van-tag>
                  <!--                                    <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.usePM">零花钱结算</van-tag>-->
                  <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.payModeName">{{item.payModeName}}</van-tag>
                  <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.rollOverAccounts">轧账余额{{item.rollOverAccounts}}</van-tag>
                  <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.repayment">已还金额{{item.repayment}}</van-tag>
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-between">
                <van-col span="22" >
                  <span style="float: left;color:#969799;font-size: 12px">{{item.remark}}</span>
                </van-col>
                <van-col span="2"><van-icon name="balance-list-o" size="25" color="#1989fa" @click="qryTransDetail(item.finId,item.billType)"/></van-col>

              </van-row>
            </template>

          </van-cell>
          <template slot="right">
            <van-button square plain type="info" text="修改" class="upd-button" @click="alterFin(item.finId)"/>
            <van-button square plain type="danger" text="删除" class="upd-button" @click="removeFin(item.finId)"/>
          </template>
          <template slot="left">
            <van-button square plain type="info" text="在途" class="upd-button" @click="alterTransFin(item.finId)"/>
          </template>
        </van-swipe-cell>
      </van-list>

    </van-pull-refresh>
    <van-popup v-model="popupShow" round closeable position="bottom" :style="{ width: '100%',height: '80%' }" >
      <trans-fin-list-detail :qry-data="qryDetailData" :refresh-index="refreshDetailIndex"></trans-fin-list-detail>
    </van-popup>

  </div>

</template>

<script>
import * as MyApi from '../../api/URLApiAddr.js'
import * as BusiConsts from '../../common/BusiConsts.js'
import TransFinListDetail from './TransFinListDetail.vue'
export default {
  name: 'TransFinList',
  components: {
    TransFinListDetail
  },
  props:{
    qryData:{
      type: Object
    },
    refreshIndex:{
      type: Number
    },
    titleIsShow:{
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      title: '账单详情',
      titleShow: this.titleIsShow,
      list: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      tagType: "danger",
      pageInfo:{
        billTypes: this.qryData['billTypes'],
        billStatus: this.qryData['billStatus'],
        current:1,
        size:50,
        total:-1,
      },
      popupShow: false,
      overdraftArr: [BusiConsts.BILL_TYPE_OVERDRAFT,BusiConsts.BILL_TYPE_OVERDRAFT_STORE],//分期型类型
      storeArr:[BusiConsts.BILL_TYPE_OVERDRAFT_STORE,BusiConsts.BILL_TYPE_STORED_VALUE], //储值型类型
      qryDetailData:{

      },
      refreshDetailIndex: 0

    }
  },
  watch:{
    refreshIndex(){
      this.onRefresh()
    }
  },
  methods: {
    onLoad() {
      this.pageInfo.billTypes = this.qryData['billTypes']
      this.pageInfo.billStatus = this.qryData['billStatus']
      if (this.refreshing) {
        this.list = [];
        this.pageInfo.current = 1
        this.pageInfo.total=-1
        this.refreshing = false
      }

      let ths = this
      if(this.list.length == this.pageInfo.total){
        this.finished = true;
        return false
      }
      let params = this.pageInfo
      this.$axios.post(MyApi.QRY_FIN_LIST,params/*,options*/)
          .then((response) =>  {
            debugger
            let code = response.code;
            if(code == '200'){

              let data = response.data
              if(data.records.length >0){
                ths.pageInfo.current ++

                //ths.list = data.records
                ths.list = ths.list.concat(data.records)
                ths.pageInfo.total = data.total;
                if(ths.list.length == data.records.total){
                  this.finished = true;
                }

              }else{
                this.finished = true;
              }
            }
            this.loading = false;

          })
          .catch((err) =>{
            this.loading = false
            this.error = true
            this.$toast.fail("数据初始化异常"+err);
          })

    },
    splitDate(inputDate) {
      return inputDate.substr(0,10)
    },
    splitTime(inputDate) {
      return inputDate.substr(11,5)
    },
    getFinType(finType){
      if(finType == BusiConsts.FIN_TYPE_PAY){
        return "danger"
      }else{
        return  "primary"
      }
      //return finTypeName
    },
    getBillType(billType){
      if(billType == BusiConsts.BILL_TYPE_OVERDRAFT){
        return "primary"
      }else{
        return  "success"
      }
      //return finTypeName
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    alterFin(finId){
      this.$router.push({ name:'finance',params:{finId:finId} })
    },
    removeFin(finId){
      this.$dialog.confirm({
        title: '删除',
        message: '确认删除该数据吗？'
      }).then(() => {
        let params = {"finId":finId}
        this.$axios.post(MyApi.FINANCE_DEL_URL,params/*,options*/)
            .then((response) =>  {
              debugger
              let code = response.code;
              if(code == '200'){
                this.$toast.success(response.msg);
                // 清空列表数据
                this.finished = false;
                this.refreshing = true;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
              }
            })
            .catch((err) =>{
              this.$toast.fail("删除异常"+err);
            })

      }).catch(() => {

      });
    },
    qryTransDetail(finId,billType){
      this.qryDetailData['finId'] = finId
      this.qryDetailData['billType'] = billType
      this.refreshDetailIndex ++
      this.popupShow = true
    },
    alterTransFin(finId){
      let month = this.pageInfo.month
      this.$router.push({ name:'tranceFinance',params:{finId:finId,month:month} })
    },
    checkInteger(value){
      if(value <= 0){
        return 0;
      }
      return value;
    }
  }

}


</script>

<style scoped="scoped">
.upd-button {
  height: 100%;
}
.van-list >>> .van-list__finished-text{
  margin-bottom: 50px;
}


</style>
